import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.iterator.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref } from "vue";
var _hoisted_1 = {
  class: "tw-flex tw-gap-x-5px tw-items-center"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  innerHTML: 'Annuncio aggiunto ai preferiti'
}, null, -1 /* HOISTED */);
var _hoisted_4 = {
  class: "tw-text-18 sm:tw-text-22 tw-font-semibold"
};
var _hoisted_5 = {
  class: "tw-text tw-mb-20px"
};
var _hoisted_6 = {
  class: "tw-grid tw-grid-cols-12 tw-items-center"
};
var _hoisted_7 = {
  class: "tw-col-span-12 sm:tw-col-span-6 tw-font-semibold tw-text-16"
};
var _hoisted_8 = {
  class: "tw-col-span-12 sm:tw-col-span-6 tw-mt-10px sm:tw-mt-0"
};
var _hoisted_9 = {
  class: "tw-flex tw-justify-center"
};
var _hoisted_10 = ["innerHTML"];
import BaseBtModal from "../BaseBtModal.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
import BaseAlert from "@vueEntry/UIKitComponents/BaseAlert.vue";
//@ts-ignore
import BaseComplexToggle from "@vueEntry/UIKitComponents/BaseComplexToggle.vue";
import { ref, defineAsyncComponent, computed, onMounted } from "vue";
import { getPlaceFromPlaceID } from "@services/geographyAPI";
//@ts-ignore
import { useLoggedUserStore } from "@store/LoggedUserStore";
//@ts-ignore
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
export default /*#__PURE__*/_defineComponent({
  __name: 'MailAlertOnFavouriteModal',
  props: {
    labels: {},
    showModal: {
      type: Boolean
    },
    placeId: {},
    formDetailInputValues: {},
    serializedResb: {},
    serializedPlace: {},
    alertIcon: {}
  },
  emits: ["alertTypeChanged", "opened", "closed", "confirmMailAlert", "openSignInModal", "openLoginModal"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    //@ts-ignore
    var successModal = defineAsyncComponent(() => import("./Status/SuccessModal.vue"));
    var limitModal = defineAsyncComponent(() => import("./Status/LimitModal.vue"));
    var unauthorizedModal = defineAsyncComponent(() => import("./Status/UnauthorizedModal.vue"));
    var limitSavedModal = defineAsyncComponent(() => import("./Status/LimitSavedModal.vue"));
    var loggedUserStore = useLoggedUserStore();
    var publicUserMenuStore = usePublicUserMenuStore();
    var props = __props;
    var emits = __emit;
    var isInstant = ref(true);
    var isLoading = ref(false);
    var alertType = ref("");
    var requestData = ref({
      title: "",
      email: "",
      privacy: false,
      dailyAlert: true
    });
    var responseCode = ref(1);
    var showErrorMessage = ref(false);
    var realEstateSearchBean = {};
    var place = ref(null);
    var labelFromWindow = computed(() => {
      return window["saveSearchData"]["labels"];
    });
    onMounted(() => __awaiter(this, void 0, void 0, function* () {
      realEstateSearchBean = JSON.parse(props.serializedResb);
      var placeID = realEstateSearchBean.placeId || parseInt("".concat(props.placeId), 10);
      place.value = props.serializedPlace ? JSON.parse(props.serializedPlace) : yield getPlaceFromPlaceID(placeID);
      if (props.formDetailInputValues) {
        var {
          cityId,
          zoneId,
          provinceId
        } = props.formDetailInputValues;
        realEstateSearchBean.cityId = cityId;
        realEstateSearchBean.zoneId = zoneId;
        realEstateSearchBean.provinceId = provinceId;
      }
    }));
    var onOpened = () => {
      emits("opened");
    };
    var onClosed = () => {
      emits("closed");
    };
    var openSignInModal = () => {
      emits("openSignInModal");
    };
    var openLoginModal = () => {
      emits("openLoginModal");
    };
    var switchAlert = v => {
      if (v === props.labels.instant) isInstant.value = true;else if (v === props.labels.daily) isInstant.value = false;
      // waiting for inactive alert?
    };
    var handleMailAlertConfirm = () => __awaiter(this, void 0, void 0, function* () {
      requestData.value.privacy = true;
      requestData.value.title = labelFromWindow.value.defaultSearchTitle;
      requestData.value.email = loggedUserStore.isUserLogged ? publicUserMenuStore.email : "";
      requestData.value.dailyAlert = isInstant.value;
      isLoading.value = true;
      try {
        //Caveat: hourly stands for immediate notification which corresponds to dailyAlert === false.
        yield publicUserMenuStore.addSaveSearch({
          email: requestData.value.email,
          title: requestData.value.title,
          hourly: !requestData.value.dailyAlert,
          resb: realEstateSearchBean
        });
        //TODO: aggiungere track di GAEvent per mail alert save - sendMailAlertSaveGAEvent()
        window["dataLayer"].push({
          /* GA4 */
          "event_name": "mail_alert_save",
          "event_location": "".concat(window["_currentPageName"], ": Popup")
        });
        //Showing success modal!
        responseCode.value = 200;
        return true;
      } catch (err) {
        console.error(err);
        var {
          response
        } = err;
        if (!response) {
          //Generic error
          showErrorMessage.value = true;
          return false;
        }
        //Showing error modal or default error message
        if (response.status === 401 || response.status === 405 || response.status === 409 || response.status === 412) responseCode.value = response.status;else
          //Generic error
          showErrorMessage.value = true;
        return false;
      } finally {
        isLoading.value = false;
      }
    });
    return (_ctx, _cache) => {
      return responseCode.value === 1 ? (_openBlock(), _createBlock(BaseBtModal, {
        key: 0,
        id: "mail-alert-on-favourite-modal",
        "data-cy": "mail-alert-on-favourite-modal",
        "show-modal": _ctx.showModal,
        "custom-modal-dialog-classes": "modal-md",
        "custom-modal-header-classes": "tw-px-20px",
        "custom-modal-body-classes": "tw-py-10px tw-px-20px",
        "custom-modal-footer-classes": "tw-px-0 sm:tw-px-5px",
        "with-custom-footer": true,
        "with-close-icon": true,
        onOpened: onOpened,
        onClosed: onClosed
      }, {
        header: _withCtx(() => [_createVNode(BaseAlert, {
          "alrt-class": "tw-alert tw-alert-w-primary tw-mr-35px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
            src: _ctx.alertIcon,
            width: "20",
            height: "20",
            alt: "warning icon"
          }, null, 8 /* PROPS */, _hoisted_2), _hoisted_3])]),
          _: 1 /* STABLE */
        })]),
        body: _withCtx(() => [_createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.labels.title), 1 /* TEXT */), _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.labels.description), 1 /* TEXT */), _createCommentVNode(" TOGGLE MAIL ALERT "), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.labels.subtitle), 1 /* TEXT */), _createElementVNode("div", _hoisted_8, [_createVNode(BaseComplexToggle, {
          class: "tw-self-center tw-mx-auto",
          type: "padded",
          mode: "mobile",
          labels: {
            leftToggle: {
              label: _ctx.labels.instant,
              checked: isInstant.value
            },
            rightToggle: {
              label: _ctx.labels.daily,
              checked: !isInstant.value
            }
          },
          "model-value": alertType.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = v => switchAlert(v))
        }, null, 8 /* PROPS */, ["labels", "model-value"])])])]),
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_createVNode(BaseButton, {
          "data-cy": "mail-alert-confirm",
          class: "tw-self-start tw-mx-0 sm:tw-mx-auto tw-w-full w-sm-auto sm:tw-max-w-[172px] tw-mt-20px sm:tw-mt-0",
          "btn-class": "tw-btn-w-primary",
          "is-loading": isLoading.value,
          onClick: handleMailAlertConfirm
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.labels.confirm), 1 /* TEXT */)]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["is-loading"])]), showErrorMessage.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "tw-text-right tw-text-w-danger tw-mr-15px tw-my-5px",
          innerHTML: labelFromWindow.value.description
        }, null, 8 /* PROPS */, _hoisted_10)) : _createCommentVNode("v-if", true)]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show-modal"])) : responseCode.value === 200 ? (_openBlock(), _createBlock(_unref(successModal), {
        key: 1,
        "show-modal": true,
        labels: {
          title: labelFromWindow.value.successModalTitle,
          description1: labelFromWindow.value.description1,
          description2_1: labelFromWindow.value.description2_1,
          description2_2: labelFromWindow.value.description2_2,
          confirm_link: labelFromWindow.value.confirm_link,
          description_no_logged: labelFromWindow.value.description_no_logged
        },
        "is-logged": _unref(loggedUserStore).isUserLogged,
        "is-mail-confirmed": _unref(publicUserMenuStore).mailConfirmed,
        "with-close-icon": true,
        onClosed: onClosed
      }, null, 8 /* PROPS */, ["labels", "is-logged", "is-mail-confirmed"])) : responseCode.value === 412 ? (_openBlock(), _createBlock(_unref(limitModal), {
        key: 2,
        "show-modal": true,
        "with-close-icon": true,
        labels: {
          title: labelFromWindow.value.limitModalTitle,
          reached_limit: labelFromWindow.value.reached_limit,
          sign_in: labelFromWindow.value.sign_in
        },
        onClosed: onClosed,
        onOpenSigninModal: openSignInModal
      }, null, 8 /* PROPS */, ["labels"])) : responseCode.value === 401 ? (_openBlock(), _createBlock(_unref(unauthorizedModal), {
        key: 3,
        "show-modal": true,
        "with-close-icon": true,
        labels: {
          title: labelFromWindow.value.unauthorizedTitle,
          unauthorized: labelFromWindow.value.unauthorized,
          login: labelFromWindow.value.login
        },
        onClosed: onClosed,
        onOpenLoginModal: openLoginModal
      }, null, 8 /* PROPS */, ["labels"])) : responseCode.value === 405 || responseCode.value === 409 ? (_openBlock(), _createBlock(_unref(limitSavedModal), {
        key: 4,
        "show-modal": true,
        "with-close-icon": true,
        labels: {
          title: labelFromWindow.value.generic_error,
          limit_saved: responseCode.value === 405 ? labelFromWindow.value.limit_saved_not_logged : labelFromWindow.value.limit_saved_logged
        },
        onClosed: onClosed
      }, null, 8 /* PROPS */, ["labels"])) : _createCommentVNode("v-if", true);
    };
  }
});